import {Product} from '@/_application/modules/products/model/product';
import {Brands} from '@/framework/static/brands';

export const getProductBrand = (product: Product) => {
    return Brands.find(brand => brand.id === product?.brand);
};
